import { render, staticRenderFns } from "./ModattaStepInteractionValidateUrlToLikeFacebookPage.vue?vue&type=template&id=bb71db1e"
import script from "./ModattaStepInteractionValidateUrlToLikeFacebookPage.vue?vue&type=script&lang=js"
export * from "./ModattaStepInteractionValidateUrlToLikeFacebookPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports